<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 2L2 5L5 8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9 5L2.25 5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11 14L14 11L11 8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7 11L13.75 11" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
